export const Loading = () => {
  return <div className="lds-dual-ring"></div>
}
